import React, { useContext, useEffect, useMemo, useState } from "react";
import { ListContainer } from "./styles";
import NotificationCard from "./NotificationCard";
import { NotificationsContext } from "../../context";
import { EditorContext } from "../../editor/context/EditorContext/EditorProvider";

const NotificationList = props => {
  const { notifications, markAllAsRead, readNotification, unread } = useContext(
    NotificationsContext
  );
  const editor = useContext(EditorContext);

  // Hide "Mark all as read" instantly on click for feedback; clear the flag
  // once the server catches up (unread hits 0) so it can reappear for new ones.
  const [marked, setMarked] = useState(false);
  useEffect(() => {
    if (unread === 0) setMarked(false);
  }, [unread]);

  useEffect(() => {
    const customMixNotifications = document.getElementsByClassName(
      "notification-editor-custommix"
    );
    for (let notificationEl of customMixNotifications) {
      notificationEl.onclick = () => {
        const idArr = notificationEl.id.split("_");
        const idVersionPair = idArr[idArr.length - 1];
        const customMixId = idVersionPair.split(":")[0];
        const versionNumber = idVersionPair.split(":")[1];
        editor.requestCustomMixIdOpen(customMixId, versionNumber, () => {
          props.setVisible(false);
        });
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications, props.setVisible]);

  const notificationsCompressed = useMemo(
    () =>
      Array.from(
        Map.groupBy(
          notifications,
          n => n.payload.name + ",*," + n.payload.body
        ).values(),
        ([first, ...rest]) => ({
          ...first,
          repeats: rest.filter(n => !n.status).map(n => n.id),
          created_at: Math.max(
            +first.created_at,
            ...rest.map(n => +n.created_at)
          ).toString(),
          status: first.status && rest.every(n => n.status)
        })
      ),
    [notifications]
  );

  return (
    <ListContainer>
      <div className="header">
        <p className="p2b">Activity</p>{" "}
        {unread > 0 && !marked && (
          <div className="read-all">
            <p
              className="p4m"
              onClick={() => {
                markAllAsRead();
                setMarked(true);
              }}
            >
              Mark all as read
            </p>
          </div>
        )}
      </div>

      <div className="scroll-area">
        {notifications &&
          notificationsCompressed.map(item => (
            <NotificationCard
              key={item.id}
              onClick={() => {
                readNotification(notifications, item.id);
                (item.repeats || []).forEach(id =>
                  readNotification(notifications, id)
                );
              }}
              onClose={props.onClose}
              notification={item}
            />
          ))}
        {notifications.length === 0 && (
          <div className="no-notifications">
            <p> No new notifications</p>{" "}
          </div>
        )}
      </div>
    </ListContainer>
  );
};

export default NotificationList;
